module.exports = __webpack_public_path__ + "static/img/img02.8ce90385.png";